import {create} from 'react-modal-promise';

import {CustomPercentileModal} from './custom-percentile-modal';

export const openCustomPercentileModal = create(CustomPercentileModal);
